import type { ApiClient } from '../client';
import { ExclusionListUsersSchema, type ExcludedUser } from '../schemas/exclusionList';

// The slug is the carrier's `courier.slug` and part of the PATH. Callers pass a catalog constant
// the panel owns ('amazon'), never input, so there is nothing to escape.
export async function fetchExclusionListUsers(
  client: ApiClient,
  slug: string,
): Promise<ExcludedUser[]> {
  const data = await client.get<unknown>(`/app_service/panel/v1/exclusion-lists/${slug}/users/`);
  return ExclusionListUsersSchema.parse(data).users;
}

// The phone travels in the BODY, E.164 as the caller validated it. 201 with an empty body, so
// there is nothing to parse; a phone no live account holds answers 400 `unregistered_user`, which
// surfaces as an `ApiError` for the host to map.
export async function addUserToExclusionList(
  client: ApiClient,
  slug: string,
  phone: string,
): Promise<void> {
  await client.post(`/app_service/panel/v1/exclusion-lists/${slug}/users/`, { phone });
}

// The id comes from a row of the listing, never from an input: `String()` over a number can only
// write digits.
export async function removeUserFromExclusionList(
  client: ApiClient,
  slug: string,
  userId: number,
): Promise<void> {
  await client.delete(
    `/app_service/panel/v1/exclusion-lists/${slug}/users/${String(userId)}/`,
  );
}
